export default __webpack_public_path__ + "static/media/videocamera.7863f436.png";